import { VITE_NETWORK_TYPE } from './env';

export const ALEO_NETWORK = VITE_NETWORK_TYPE === 'mainnet' ? 'mainnet' : 'testnet';
export const RECORD_PLAINTEXT_KEY = { 'Puzzle Wallet': 'plaintext', 'Shield Wallet': 'recordPlaintext' };
